import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface GetClaimProductQueryArgs {
  claimId: string;
}

export const getClaimProductRequest = ({
  claimId,
}: GetClaimProductQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/product`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimProductQuery = async (
  args: GetClaimProductQueryArgs,
): Promise<BackResponse<Record<string, unknown>> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<Record<string, unknown>>>(
      getClaimProductRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
